<frontend-menu
  [list]="list$ | async"
  [unread]="unread$ | async"
  (searchUpdate)="onSearchUpdate($event)"
></frontend-menu>
